export enum DealMachineNodes {
  GENERAL = 'GENERAL',
  FINANCIAL = 'FINANCIAL',
  SECURITY_TYPE = 'SECURITY_TYPE',
  INVESTMENT_MEMO = 'INVESTMENT_MEMO',
}
